module.exports = __webpack_public_path__ + "img/bingo_ball-90.757a645c.png";